import React from 'react'
import './blogs.css'
import { blogs } from '../../utils/blogData'

const Blogs = () => {
  return(
    <div id='blogs' className='bg-info-subtle p-5 mt-5'>
      <div className='container'>
        <div className='d-flex justify-content-between align-items-center'>
          <h1 className='fw-bolder fs-2'>My Latest <span className='fw-medium fst-italic text-primary'>Blog Posts</span></h1>
          <a href='https://aayush-srivastava.hashnode.dev/' target="_blank" rel="noopener noreferrer">
            <button className='btn blog-btn rounded-pill text-light fw-medium fs-5' style={{ width: '200px' }}>View All Blogs &rarr;</button>
          </a>
        </div>
        <div className='blogsWrapper row justify-content-center pt-5 gap-5'>
        {blogs.map(blog => {
            return(
              <div className="card bg-light col-md-4 border-0 shadow" style={{ width: '400px' }}>
                <img src={blog.image} className="card-img-top" alt='...' style={{ height: '200px'}}/>
                <div className="card-body">
                  <div className='justify-content-center gap-2 row p-2'>
                    {blog.tags.map(tag => <div className='col badge text-bg-warning rounded-pill'>{tag}</div>)}
                  </div>
                  <div className='row p-2'>
                    <p className="card-text col-8 fs-6 fw-bolder text-secondary">{blog.title}</p>
                    <a className='col' href={blog.url} target="_blank" rel="noopener noreferrer">
                      <button className='btn btn-primary text-light fs-2 rounded-3'>&rarr;</button>
                    </a>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default Blogs